var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"space-y-5 p-4"},_vm._l((_vm.cardCount),function(i){return _c('div',{key:i,staticClass:"h-17 animate-pulse bg-ink-300"})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }